module.exports = __webpack_public_path__ + "static/media/Arrow_Right_To_Orange.e0924d36.svg";